module.exports = __webpack_public_path__ + "img/colorful2-end.d7360448.png";